import React from "react";
import Hero from "@/components/Common/Hero";
import BrandWeBuy from "@/components/Common/BrandWeBuy";
import SellYourWatches from "@/components/WhatWeBuy/SellYourWatches";
import SellYourDiamonds from "@/components/WhatWeBuy/SellYourDiamonds";
import SellYourJewellery from "@/components/WhatWeBuy/SellYourJewellery";
import Coins from "@/components/WhatWeBuy/Coins";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FeaturedOn from "@/components/Common/FeaturedOn";
import HowItWorks from "@/components/Common/HowItWorks";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import { createClient } from "../../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import SellYourBags from "@/components/WhatWeBuy/SellYourBags";
import { SliceZone } from "@prismicio/react";
import FeatureDetailsSlice from "@/components/FeaturesDetails/FeatureDetails";
import FAQ from "@/components/Common/FAQ";
import SchemaScript from "@/components/SchemaScript";

const WhatWeBuy = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const brand = {
    title: pageData?.brand_we_buy_title,
    logo: pageData?.brand_we_buy_logo,
  };

  const watches = {
    title: pageData?.sell_watches_title,
    desc: pageData?.sell_watches_description,
    buttonText: pageData?.sell_watches_button_text,
    watches: pageData?.sell_watches_image,
    viewLink: pageData?.watches_view_more_link,
  };

  const diamonds = {
    title: pageData?.sell_diamonds_title,
    desc: pageData?.sell_diamonds_description,
    buttonText: pageData?.sell_diamonds_button_text,
    diamonds: pageData?.sell_diamonds_image,
    viewLink: pageData?.diamonds_view_more_link,
  };

  const jewellery = {
    title: pageData?.sell_jewellery_title,
    desc: pageData?.sell_jewellery_description,
    buttonText: pageData?.sell_jewellery_button_text,
    jewellery: pageData?.sell_jewellery_image,
    viewLink: pageData?.jewellery_view_more_link,
  };

  const bags = {
    title: pageData?.sell_bags_title,
    desc: pageData?.sell_bags_description,
    buttonText: pageData?.sell_bags_button_text,
    bags: pageData?.sell_bags_image,
    viewLink: pageData?.bags_view_more_link,
  };

  const coin = {
    coin: pageData?.coins,
  };

  const components = {
    features_details: FeatureDetailsSlice,
    faqs: FAQ,
  };

  return (
    <Layout data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy"
      />
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageMobile={pageData?.hero_background_image_mobile}
        backgroundImageTab={pageData?.hero_background_image_tab}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        opacity={false}
        page={"What We Buy"}
      />
      <Breadcrumbs />
      <BrandWeBuy data={brand} />
      <SellYourWatches data={watches} page={"What We Buy"} />
      <SellYourDiamonds data={diamonds} page={"What We Buy"} />
      <SellYourJewellery data={jewellery} page={"What We Buy"} />
      <SellYourBags data={bags} page={"What We Buy"} />
      <Coins data={coin} page={"What We Buy"} />
      <TrustedByMany data={commonComponents} page={"What We Buy"} />
      <FeaturedOn data={commonComponents} />
      <HowItWorks data={commonComponents} />
      <SliceZone slices={page?.data?.slices} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"What We Buy"} />
    </Layout>
  );
};

export default WhatWeBuy;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("what_we_buy_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
